import { render, staticRenderFns } from "./AddRecordToContactForm.vue?vue&type=template&id=013760e5&scoped=true&"
import script from "./AddRecordToContactForm.vue?vue&type=script&lang=js&"
export * from "./AddRecordToContactForm.vue?vue&type=script&lang=js&"
import style0 from "./AddRecordToContactForm.vue?vue&type=style&index=0&id=013760e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013760e5",
  null
  
)

export default component.exports